import { TournamentEntity } from '@/api/tournament'
import { getModule } from 'vuex-module-decorators'
import store from '@/store'
import userStore from '@/modules/auth/auth.store'
import memberStore from '@/modules/member/member.store'

let dialogCallback: Function | null = null

async function invokeDialogCallback() {
  const userModule = getModule(userStore, store)
  await userModule.fetchAccountInfo()

  if (dialogCallback) {
    dialogCallback()
  }

  dialogCallback = null
}

async function ensureTournamentVerification(params: {
  tournament: TournamentEntity
  callback: Function
}) {
  const userModule = getModule(userStore, store)
  const memberModule = getModule(memberStore, store)

  // Only enable phone number checks on production build
  if (
    (process && process.env && process.env.NODE_ENV === 'production') ||
    window.location.search.indexOf('usePhone=1') !== -1
  ) {
    if (
      !userModule.accountInfo ||
      !userModule.accountInfo.phoneNumberConfirmed
    ) {
      await memberModule.setIsPhoneVerificationVisible({ isVisible: true })

      dialogCallback = params.callback
      return false
    }
  } else {
    console.warn(
      '[DEBUG] Phone number verification has been bypassed in non-production build.'
    )
  }

  // check discord ID
  if (params.tournament.isDiscordIdRequired) {
    if (!userModule.accountInfo || !userModule.accountInfo.discordId) {
      await memberModule.setIsDiscordIdDialogVisible({
        isVisible: true
      })

      dialogCallback = params.callback
      return false
    }
  }

  return true
}

export { ensureTournamentVerification, invokeDialogCallback }
